var i=(e,s)=>{let n=new URL(e);return Object.entries(s).forEach(([t,r])=>{r!=null&&t&&n.searchParams.set(t,r.toString());}),n.toString()};export{i as a};//# sourceMappingURL=chunk-XODTQSZL.mjs.map
//# sourceMappingURL=chunk-XODTQSZL.mjs.map